import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MappingType = /*#__PURE__*/function (MappingType) {
  MappingType[MappingType["MAPPING_TYPE_UNSPECIFIED"] = 0] = "MAPPING_TYPE_UNSPECIFIED";
  MappingType[MappingType["MAPPING_TYPE_LOOKUP_CUSTOM_FIELD"] = 1] = "MAPPING_TYPE_LOOKUP_CUSTOM_FIELD";
  MappingType[MappingType["MAPPING_TYPE_CUSTOM_FIELD"] = 2] = "MAPPING_TYPE_CUSTOM_FIELD";
  MappingType[MappingType["MAPPING_TYPE_SYSTEM_FIELD"] = 3] = "MAPPING_TYPE_SYSTEM_FIELD";
  return MappingType;
}(MappingType || {});
var MergeStrategyType = /*#__PURE__*/function (MergeStrategyType) {
  MergeStrategyType[MergeStrategyType["MERGE_STRATEGY_UNSPECIFIED"] = 0] = "MERGE_STRATEGY_UNSPECIFIED";
  MergeStrategyType[MergeStrategyType["MERGE_STRATEGY_ALWAYS_OVERWRITE"] = 1] = "MERGE_STRATEGY_ALWAYS_OVERWRITE";
  MergeStrategyType[MergeStrategyType["MERGE_STRATEGY_OVERWRITE_IF_EMPTY"] = 2] = "MERGE_STRATEGY_OVERWRITE_IF_EMPTY";
  MergeStrategyType[MergeStrategyType["MERGE_STRATEGY_OVERWRITE_IF_NEWER"] = 3] = "MERGE_STRATEGY_OVERWRITE_IF_NEWER";
  MergeStrategyType[MergeStrategyType["MERGE_STRATEGY_COMBINE"] = 4] = "MERGE_STRATEGY_COMBINE";
  return MergeStrategyType;
}(MergeStrategyType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AddContactAsIamUserForCompanyStatus = /*#__PURE__*/function (AddContactAsIamUserForCompanyStatus) {
  AddContactAsIamUserForCompanyStatus[AddContactAsIamUserForCompanyStatus["ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_INVALID"] = 0] = "ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_INVALID";
  AddContactAsIamUserForCompanyStatus[AddContactAsIamUserForCompanyStatus["ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_IN_PROGRESS"] = 1] = "ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_IN_PROGRESS";
  AddContactAsIamUserForCompanyStatus[AddContactAsIamUserForCompanyStatus["ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_SUCCEEDED"] = 2] = "ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_SUCCEEDED";
  AddContactAsIamUserForCompanyStatus[AddContactAsIamUserForCompanyStatus["ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_FAILED"] = 3] = "ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_FAILED";
  return AddContactAsIamUserForCompanyStatus;
}(AddContactAsIamUserForCompanyStatus || {});
var CreateAccountGroupForCompanyStatus = /*#__PURE__*/function (CreateAccountGroupForCompanyStatus) {
  CreateAccountGroupForCompanyStatus[CreateAccountGroupForCompanyStatus["CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_UNSPECIFIED"] = 0] = "CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_UNSPECIFIED";
  CreateAccountGroupForCompanyStatus[CreateAccountGroupForCompanyStatus["CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_IN_PROGRESS"] = 1] = "CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_IN_PROGRESS";
  CreateAccountGroupForCompanyStatus[CreateAccountGroupForCompanyStatus["CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_SUCCEEDED"] = 2] = "CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_SUCCEEDED";
  CreateAccountGroupForCompanyStatus[CreateAccountGroupForCompanyStatus["CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_FAILED"] = 3] = "CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_FAILED";
  return CreateAccountGroupForCompanyStatus;
}(CreateAccountGroupForCompanyStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateIntegrationRequest {
  static fromProto(proto) {
    let m = new CreateIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.integration) {
      m.integration = Integration.fromProto(proto.integration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integration !== 'undefined' && this.integration !== null) {
      toReturn['integration'] = 'toApiJson' in this.integration ? this.integration.toApiJson() : this.integration;
    }
    return toReturn;
  }
}
class CreateIntegrationResponse {
  static fromProto(proto) {
    let m = new CreateIntegrationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class MergeStrategyMergeConfigDateOverwriteConfig {
  static fromProto(proto) {
    let m = new MergeStrategyMergeConfigDateOverwriteConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateCriteriaFieldId !== 'undefined') {
      toReturn['dateCriteriaFieldId'] = this.dateCriteriaFieldId;
    }
    return toReturn;
  }
}
class DeleteIntegrationRequest {
  static fromProto(proto) {
    let m = new DeleteIntegrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class FieldMapping {
  static fromProto(proto) {
    let m = new FieldMapping();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$2(MappingType, proto.type);
    }
    if (proto.mergeStrategy) {
      m.mergeStrategy = MergeStrategy.fromProto(proto.mergeStrategy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.jsonPath !== 'undefined') {
      toReturn['jsonPath'] = this.jsonPath;
    }
    if (typeof this.mergeStrategy !== 'undefined' && this.mergeStrategy !== null) {
      toReturn['mergeStrategy'] = 'toApiJson' in this.mergeStrategy ? this.mergeStrategy.toApiJson() : this.mergeStrategy;
    }
    return toReturn;
  }
}
class GetMultiIntegrationRequest {
  static fromProto(proto) {
    let m = new GetMultiIntegrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationIds !== 'undefined') {
      toReturn['integrationIds'] = this.integrationIds;
    }
    return toReturn;
  }
}
class GetMultiIntegrationResponse {
  static fromProto(proto) {
    let m = new GetMultiIntegrationResponse();
    m = Object.assign(m, proto);
    if (proto.integrations) {
      m.integrations = proto.integrations.map(Integration.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrations !== 'undefined' && this.integrations !== null) {
      toReturn['integrations'] = 'toApiJson' in this.integrations ? this.integrations.toApiJson() : this.integrations;
    }
    return toReturn;
  }
}
class Integration {
  static fromProto(proto) {
    let m = new Integration();
    m = Object.assign(m, proto);
    if (proto.fieldMappings) {
      m.fieldMappings = proto.fieldMappings.map(FieldMapping.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.objectType !== 'undefined') {
      toReturn['objectType'] = this.objectType;
    }
    if (typeof this.objectSubtype !== 'undefined') {
      toReturn['objectSubtype'] = this.objectSubtype;
    }
    if (typeof this.lookupMappingIds !== 'undefined') {
      toReturn['lookupMappingIds'] = this.lookupMappingIds;
    }
    if (typeof this.fieldMappings !== 'undefined' && this.fieldMappings !== null) {
      toReturn['fieldMappings'] = 'toApiJson' in this.fieldMappings ? this.fieldMappings.toApiJson() : this.fieldMappings;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class MergeStrategyMergeConfig {
  static fromProto(proto) {
    let m = new MergeStrategyMergeConfig();
    m = Object.assign(m, proto);
    if (proto.dateOverwriteConfig) {
      m.dateOverwriteConfig = MergeStrategyMergeConfigDateOverwriteConfig.fromProto(proto.dateOverwriteConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateOverwriteConfig !== 'undefined' && this.dateOverwriteConfig !== null) {
      toReturn['dateOverwriteConfig'] = 'toApiJson' in this.dateOverwriteConfig ? this.dateOverwriteConfig.toApiJson() : this.dateOverwriteConfig;
    }
    return toReturn;
  }
}
class MergeStrategy {
  static fromProto(proto) {
    let m = new MergeStrategy();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$2(MergeStrategyType, proto.type);
    }
    if (proto.config) {
      m.config = MergeStrategyMergeConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class UpdateIntegrationRequest {
  static fromProto(proto) {
    let m = new UpdateIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.integration) {
      m.integration = Integration.fromProto(proto.integration);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integration !== 'undefined' && this.integration !== null) {
      toReturn['integration'] = 'toApiJson' in this.integration ? this.integration.toApiJson() : this.integration;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DeleteObjectRequest {
  static fromProto(proto) {
    let m = new DeleteObjectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    return toReturn;
  }
}
class UpsertObjectRequest {
  static fromProto(proto) {
    let m = new UpsertObjectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    return toReturn;
  }
}
class UpsertObjectResponse {
  static fromProto(proto) {
    let m = new UpsertObjectResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddContactAsIamUserForCompanyRequest {
  static fromProto(proto) {
    let m = new AddContactAsIamUserForCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    return toReturn;
  }
}
class AddContactAsIamUserForCompanyStatusResponse {
  static fromProto(proto) {
    let m = new AddContactAsIamUserForCompanyStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(AddContactAsIamUserForCompanyStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class CreateAccountGroupForCompanyRequest {
  static fromProto(proto) {
    let m = new CreateAccountGroupForCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetAccountGroupForCompanyRequest {
  static fromProto(proto) {
    let m = new GetAccountGroupForCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetAccountGroupForCompanyResponse {
  static fromProto(proto) {
    let m = new GetAccountGroupForCompanyResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetCreateAccountGroupForCompanyStatusRequest {
  static fromProto(proto) {
    let m = new GetCreateAccountGroupForCompanyStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetCreateAccountGroupForCompanyStatusResponse {
  static fromProto(proto) {
    let m = new GetCreateAccountGroupForCompanyStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(CreateAccountGroupForCompanyStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class IsContactIamUserForCompanyRequest {
  static fromProto(proto) {
    let m = new IsContactIamUserForCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    return toReturn;
  }
}
class IsContactIamUserForCompanyResponse {
  static fromProto(proto) {
    let m = new IsContactIamUserForCompanyResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isIamUser !== 'undefined') {
      toReturn['isIamUser'] = this.isIamUser;
    }
    return toReturn;
  }
}
class RemoveContactAsIamUserForCompanyRequest {
  static fromProto(proto) {
    let m = new RemoveContactAsIamUserForCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'crm-integrations-api.vendasta-local.com',
  'test': '',
  'demo': 'crm-integrations-demo.apigateway.co',
  'prod': 'crm-integrations-prod.apigateway.co',
  'production': 'crm-integrations-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let DataIngestionApiService = /*#__PURE__*/(() => {
  class DataIngestionApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsertObject(r) {
      const request = r.toApiJson ? r : new UpsertObjectRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.DataIngestionService/UpsertObject", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpsertObjectResponse.fromProto(resp)));
    }
    deleteObject(r) {
      const request = r.toApiJson ? r : new DeleteObjectRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.DataIngestionService/DeleteObject", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  DataIngestionApiService.ɵfac = function DataIngestionApiService_Factory(t) {
    return new (t || DataIngestionApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  DataIngestionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DataIngestionApiService,
    factory: DataIngestionApiService.ɵfac,
    providedIn: 'root'
  });
  return DataIngestionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let IntegrationApiService = /*#__PURE__*/(() => {
  class IntegrationApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createIntegration(r) {
      const request = r.toApiJson ? r : new CreateIntegrationRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.IntegrationService/CreateIntegration", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateIntegrationResponse.fromProto(resp)));
    }
    updateIntegration(r) {
      const request = r.toApiJson ? r : new UpdateIntegrationRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.IntegrationService/UpdateIntegration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteIntegration(r) {
      const request = r.toApiJson ? r : new DeleteIntegrationRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.IntegrationService/DeleteIntegration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiIntegration(r) {
      const request = r.toApiJson ? r : new GetMultiIntegrationRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.IntegrationService/GetMultiIntegration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiIntegrationResponse.fromProto(resp)));
    }
  }
  IntegrationApiService.ɵfac = function IntegrationApiService_Factory(t) {
    return new (t || IntegrationApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IntegrationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntegrationApiService,
    factory: IntegrationApiService.ɵfac,
    providedIn: 'root'
  });
  return IntegrationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PlatformApiService = /*#__PURE__*/(() => {
  class PlatformApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createAccountGroupForCompany(r) {
      const request = r.toApiJson ? r : new CreateAccountGroupForCompanyRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/CreateAccountGroupForCompany", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getCreateAccountGroupForCompanyStatus(r) {
      const request = r.toApiJson ? r : new GetCreateAccountGroupForCompanyStatusRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/GetCreateAccountGroupForCompanyStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCreateAccountGroupForCompanyStatusResponse.fromProto(resp)));
    }
    getAccountGroupForCompany(r) {
      const request = r.toApiJson ? r : new GetAccountGroupForCompanyRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/GetAccountGroupForCompany", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAccountGroupForCompanyResponse.fromProto(resp)));
    }
    addContactAsIamUserForCompany(r) {
      const request = r.toApiJson ? r : new AddContactAsIamUserForCompanyRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/AddContactAsIamUserForCompany", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddContactAsIamUserForCompanyStatusResponse.fromProto(resp)));
    }
    isContactIamUserForCompany(r) {
      const request = r.toApiJson ? r : new IsContactIamUserForCompanyRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/IsContactIamUserForCompany", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsContactIamUserForCompanyResponse.fromProto(resp)));
    }
    removeContactAsIamUserForCompany(r) {
      const request = r.toApiJson ? r : new RemoveContactAsIamUserForCompanyRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/RemoveContactAsIamUserForCompany", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PlatformApiService.ɵfac = function PlatformApiService_Factory(t) {
    return new (t || PlatformApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  PlatformApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PlatformApiService,
    factory: PlatformApiService.ɵfac,
    providedIn: 'root'
  });
  return PlatformApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

// MANUALLY CREATED FILE
// Don't delete this by mistake when you update the SDK with mscli!

/**
 * Generated bundle index. Do not edit.
 */

export { AddContactAsIamUserForCompanyRequest, AddContactAsIamUserForCompanyStatus, AddContactAsIamUserForCompanyStatusResponse, CreateAccountGroupForCompanyRequest, CreateAccountGroupForCompanyStatus, CreateIntegrationRequest, CreateIntegrationResponse, DataIngestionApiService, DeleteIntegrationRequest, DeleteObjectRequest, FieldMapping, FieldMask, GetAccountGroupForCompanyRequest, GetAccountGroupForCompanyResponse, GetCreateAccountGroupForCompanyStatusRequest, GetCreateAccountGroupForCompanyStatusResponse, GetMultiIntegrationRequest, GetMultiIntegrationResponse, HostService, Integration, IntegrationApiService, IsContactIamUserForCompanyRequest, IsContactIamUserForCompanyResponse, MappingType, MergeStrategy, MergeStrategyMergeConfig, MergeStrategyMergeConfigDateOverwriteConfig, MergeStrategyType, PlatformApiService, RemoveContactAsIamUserForCompanyRequest, UpdateIntegrationRequest, UpsertObjectRequest, UpsertObjectResponse };
